import { request } from "@umijs/max";
import { PersonSearchRequest, SimplifiedPerson, SimplifiedPersonSearchResponse } from "./model";

export async function searchPeople(params: PersonSearchRequest): Promise<SimplifiedPersonSearchResponse> {
  return request('/people-v2/search', {
    method: 'POST',
    data: params,
  });
}

export async function fetchPerson(personId: number, isFreePlan: boolean): Promise<SimplifiedPerson> {
  return request(`/people-v2/${personId}/${isFreePlan.toString()}`, {
    method: 'GET',
  });
}

export async function fetchPeopleListsV2(): Promise<any[]> {
  return request('/people-v2/list', {
    method: 'GET',
  });
}

export async function fetchPeopleListItemsV2(listId: number): Promise<any[]> {
  return request(`/people-v2/list-items/${listId}`, {
    method: 'GET',
  });
}

export async function createPeopleListV2(data: { name: string }): Promise<any> {
  return request('/people-v2/list', {
    method: 'POST',
    data,
  });
}

export async function addPeopleToListV2(data: { listId: number, peopleIds: number[] }): Promise<any> {
  return request('/people-v2/addPeopleToList', {
    method: 'POST',
    data,
  });
}

export async function fetchPeopleFromProductList(product_list_item_ids: number[]): Promise<any> {
  return request('/people-v2/fetch_people_from_product_list', {
    method: 'POST',
    data: { product_list_item_ids },
  });
}

export async function fetchOrganizationIndustries(query: string, page: number = 1): Promise<any> {
  return request(`/people-v2/organization-industries/${query}/${page}`, {
    method: 'GET',
  });
}

export async function fetchPersonSkills(query: string, page: number = 1): Promise<any> {
  return request(`/people-v2/skills/${query}/${page}`, {
    method: 'GET',
  });
}

export async function fetchPeopleFromProducts(productIds: number[]) {
  return request('/people-v2/fetch_people_from_products', {
    method: 'POST',
    data: {
      product_ids: productIds,
    },
  });
}